import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import GiftCardOrders from './GiftCardOrders';
import AllGiftCards from './AllGiftCards';
import AddIcon from '@material-ui/icons/Add';

import EditIcon from '@material-ui/icons/Edit';
import { dateFormatUtil } from '../Utilities';

import ReactExport from 'react-export-excel';


import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Approved', value: 'Approved' },
    { key: 'Pending', value: 'Pending' },
    { key: 'Rejected', value: 'Rejected' },
]
const searchBy = [
    { key: 'Title', value: 'title' },
];


export function MaterialUIPickers(props) {
    
    var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
    var firstDay = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();

const [selectedDate, setSelectedDate] = React.useState(firstDay);

const handleDateChange = (date) => {
    setSelectedDate(date);
    props.setDate(date);
};

return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around">
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="none"
                id={props.id}
                label={props.label}
                value={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                autoOk={true}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
            />
        </Grid>
    </MuiPickersUtilsProvider>
);
}


class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        showOrders:false,
        showGCList:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'title',
        selectedItem:[],
        DownloadReady:false,
        reportModalShow:false,
        report_from_date:this.getFormattedDate(new Date()),
        report_to_date:this.getFormattedDate(new Date()),
        report_title:'',

        modalShow: false,
        editmode: 'add',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        newamount:0,
        newbalance:0,
        balance:0,
        title:''
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    listOrders = (rowData) => {
        if (this._isMounted) {
            this.setState({ showOrders: true,showGCList: false, selectedRow: rowData });
        }
    };

    listGC = (rowData) => {
        if (this._isMounted) {
            this.setState({ showGCList: true,showOrders:false, selectedRow: rowData });
        }
    };
    
    hideOffers  = () => {
        if (this._isMounted) {
            this.setState({ showGCList: false, showOrders:false, selectedRow: [] });
        }
    };

    hideOrders = () => {
        if (this._isMounted) {
            this.setState({ showOrders: false,showGCList: false, selectedRow: [] });
        }
    };

    
    editDetail = (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,editmode:'add', modalShow: true });
        }
    } 
    updateDetail= (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,newbalance:item.balance,editmode:'update', modalShow: true });
        }
    } 
    
    UpdateConfirmed = () => {
        let newBalance =0;
        if(this.state.editmode =='add'){
             newBalance= parseFloat(this.state.selectedItem.balance)>0?parseFloat(this.state.selectedItem.balance)+parseFloat(this.state.newamount):parseFloat(this.state.newamount)
        }else{
            newBalance= parseFloat(this.state.newbalance)
        }
      
let data = {
    title: this.state.selectedItem.title?this.state.selectedItem.title:this.state.title,
    balance:newBalance,
    docID: this.state.selectedItem.docID?this.state.selectedItem.docID:'',
    LastUpdatedTimeStamp: dateFormatUtil(),
    UpdatedBy: this.props.user.FullName
        ? this.props.user.FullName
        : 'Admin'
};
     
        RestServices.updateMasterGiftCard(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                //console.log(responseData)
                this.setState({ modalShow: false });
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    this.loadData();
                    if (this._isMounted) {
                        this.setState({selectedItem:[]});
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

    }

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false ,reportModalShow: false});
        }
    };

    addReport = (item)=>{
        if (this._isMounted) {
        this.setState({DownloadReady:false,selectedItem:item, reportModalShow: true,alert:0,alertMessage:'' });
        }
    }

    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    createReport = async () => {
       
let bodyData = {
    title: this.state.report_title,
    fromDate: this.state.report_from_date,
    search_key: this.state.report_from_date,
    search_by:'Date',
    toDate: this.state.report_to_date,
    MasterGiftCard: this.state.selectedItem.title,
    LastUpdatedTimeStamp: dateFormatUtil(),
    UpdatedBy: this.props.user.FullName
        ? this.props.user.FullName
        : 'Admin'
};
     

this.setState({DownloadReady:false, flag: true,alert:0,alertMessage:''});
await RestServices.getMyGiftCards(
    localStorage.getItem('FirebaseToken'),
    bodyData
)
    .then((response) => response.json())
    .then((responseData) => {
        
        var giftcardsList =[]
        var dataList = responseData.list;
        if(dataList.length>0){
        for (let i = 0; i < dataList.length; i++) {
            if(dataList[i].status ==='COMPLETE'){
                var allCards = dataList[i].cards
                for (let c = 0; c < allCards.length; c++) {
                giftcardsList.push({
                    refno:dataList[i].refno?dataList[i].refno:'null',
                    giftOrderId:dataList[i].orderId?dataList[i].orderId:'null',
                    sku:dataList[i].GCSku?dataList[i].GCSku:'null',
                    productName:dataList[i].productName,
                    ProfileUniqeID:dataList[i].ProfileUniqeID?dataList[i].ProfileUniqeID:'null',
                    cardId:allCards[c].cardId,
                    cardNumber:allCards[c].cardNumber,
                    cardPin:allCards[c].cardPin,
                    issuanceDate:allCards[c].issuanceDate,
                    validity:allCards[c].validity,
                    amount:allCards[c].amount?parseFloat(allCards[c].amount):0,
                    Comments:dataList[i].Description?dataList[i].Description:'null',
                });
              }
            }
        }
        this.setState({DownloadReady:true,giftcardsAMACoupon:giftcardsList,alert:0,alertMessage:'',flag: false, });
    }else{
        this.setState({DownloadReady:false,flag: false,alert:1,alertMessage:'No records found...',modalShow: false });
    }
    })
        

    }

    DownloadClose = () => {
        if (this._isMounted) {
            this.setState({alert:2,alertMessage:'Report Downloaded...',selectedItem:[], reportModalShow: false });
        }
    };

    



    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showOrders && !this.state.showGCList && (
                    <div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Gift Card Accounts
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Master Gift Cards"
                            columns={[
                                {
                                    title: 'Title',
                                    field: 'title',
                                    render: (row) => (
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                color: 'blue'
                                            }}
                                            onClick={(e) =>
                                                this.listOrders(row)
                                            }
                                        >
                                            {row.title}
                                        </div>
                                    )
                                },
                                { title: 'Account Balance', field: 'balance',
                                render: (row) => (
                                    <div>
                                        <span>₹ </span>{parseFloat(row.balance).toFixed(2)}
                                        <AddIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.editDetail(row)
                                            }
                                        />

                                        <EditIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.updateDetail(row)
                                            }
                                        />
                                    </div>
                                ) },
                                { title: 'Actual Balance', field: 'accountBalance',
                                render: (row) => (
                                    <div>
                                        <span>₹ </span>{parseFloat(row.accountBalance).toFixed(2)}
                                    </div>
                                ) },
                                { title: 'Manage Gift Cards', field: '',
                                render: (row) => (
                                    <div>
                                        <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listGC(row)
                                        }
                                    >
                                        List
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={(e) =>
                                            this.addReport(row)
                                        }
                                    >
                                        Create Report
                                    </Button>
                                    </div>
                                ) },
                                
                                
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                

                


                {this.state.showOrders && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideOrders}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                All orders from {this.state.selectedRow.title}
                            </h4>
                        </Row>

                        <GiftCardOrders MasterGiftCard={this.state.selectedRow} {...this.props} />
                    </div>
                )}

            {this.state.showGCList && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideOffers}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Manage {this.state.selectedRow.title}
                            </h4>
                        </Row>

                        <AllGiftCards MasterGiftCard={this.state.selectedRow} {...this.props} />
                    </div>
                )}

                <Modal  
                    show={this.state.reportModalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                    {this.state.selectedItem.title} New Report
                    </Modal.Header>

                    <Modal.Body>
                    
                    <Form.Row>
                            <Form.Group as={Col}>
                                <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        report_from_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        report_to_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Form.Group>
                    </Form.Row>
    
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Report Title</Form.Label>
                                <Form.Control
                                    placeholder="Enter title"
                                    type="text"
                                    name="report_title"
                                    value={this.state.report_title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                    </Form.Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {!this.state.DownloadReady ?<Button variant="primary" onClick={this.createReport}>
                            Generate
                        </Button>:
                        <ExcelFile
                            element={
                                <Button variant="primary" onClick={this.DownloadClose}>
                                        Download Report
                                </Button>
                            }
                            filename={this.state.report_title}
                        >
                            <ExcelSheet
                                data={this.state.giftcardsAMACoupon}
                                name={this.state.report_title}
                            >
                                <ExcelColumn
                                    label="Order Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="Order ID"
                                    value="giftOrderId"
                                />
                                <ExcelColumn
                                    label="SKU"
                                    value="sku"
                                />
                                <ExcelColumn
                                    label="GC Name"
                                    value="productName"
                                />
                                <ExcelColumn
                                    label="GC Reference Number"
                                    value="refno"
                                />
                                <ExcelColumn
                                    label="Store ID"
                                    value="ProfileUniqeID"
                                />
                                
                                <ExcelColumn
                                    label="Amount"
                                    value="amount"
                                />
                                <ExcelColumn
                                    label="CardId"
                                    value="cardId"
                                />
                                <ExcelColumn
                                    label="CardNumber"
                                    value="cardNumber"
                                />
                                <ExcelColumn
                                    label="CardPin"
                                    value="cardPin"
                                />
                                <ExcelColumn
                                    label="Validity"
                                    value="validity"
                                />

                                <ExcelColumn
                                    label="Comments"
                                    value="Comments"
                                />
                                
                                
                            </ExcelSheet>
                        </ExcelFile>}
                        
                    </Modal.Footer>
                </Modal>

                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        {this.state.selectedItem.title ?<Modal.Title>{this.state.editmode=='add' ?<span>Add amount to </span>:<span>Edit amount of</span>}  {this.state.selectedItem.title}</Modal.Title>:<Modal.Title>{this.state.editmode=='add' ?<span>Add</span>:<span>Edit</span>} Gift Card Account</Modal.Title>}
                    </Modal.Header>

                    <Modal.Body>
                    {this.state.selectedItem.title ?<>
                        {this.state.editmode=='add' ?<Form.Group as={Col}>
                                <Form.Label>Add Amount (₹)</Form.Label>
                                <Form.Control
                                    placeholder="Enter amount to add"
                                    type="number"
                                    name="newamount"
                                    value={this.state.newamount}
                                    onChange={this.onChangeValues}
                                />
                       </Form.Group>:<Form.Group as={Col}>
                                <Form.Label>Edit Amount (₹)</Form.Label>
                                <Form.Control
                                    placeholder={this.state.newbalance}
                                    type="number"
                                    name="newbalance"
                                    value={this.state.newbalance}
                                    onChange={this.onChangeValues}
                                />
                       </Form.Group>}

                    </>:<>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    placeholder="Enter title"
                                    type="text"
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Account Balance (₹)</Form.Label>
                                <Form.Control
                                    placeholder="Enter amount"
                                    type="number"
                                    name="newamount"
                                    value={this.state.newamount}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                    </Form.Row>

                    </>}
                    

                    


                    
    
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.UpdateConfirmed}>
                        {this.state.selectedItem.title ?<>Update</>:<>Add New</>}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default AllList;
